"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasePrivateChats = void 0;
const models_1 = require("../../models");
const utils_1 = require("../../utils");
const mappers_1 = require("../../mappers");
const CollectionUtils_1 = require("../../utils/CollectionUtils");
class BasePrivateChats {
    constructor(httpAdapter, organizationUser, socketAdapter, config, userDirectory, hhnStorage) {
        this.httpAdapter = httpAdapter;
        this.organizationUser = organizationUser;
        this.organization = organizationUser.getOrganization();
        this.socketAdapter = socketAdapter;
        this.config = config;
        this.userDirectory = userDirectory;
        this.hhnStorage = hhnStorage;
    }
    buildFetchChatsRequest() {
        const chatList = this.getChatsStorage().getChatListByType(models_1.GROUP_TYPE.PRIVATE);
        const request = {
            chatType: models_1.CHAT_TYPE.PRIVATE,
            limit: utils_1.HHNConstants.PAGINATION_LIMIT,
            total: chatList && chatList.chats.length > 0 ? chatList.chats.length : 0,
        };
        return request;
    }
    prepareChatList(chatListOptional) {
        return Object.assign(Object.assign({}, chatListOptional), { chats: chatListOptional.chats.reduce((result, chat) => {
                const userInfo = this.userDirectory.getUserInfo(chat.id);
                result.push(Object.assign(Object.assign({}, chat), { userInfo }));
                return result;
            }, []) });
    }
    populateChatList(newChats, order, mergeHandler, showMergedChatsOnTop, chatFilters) {
        let chatList = this.getChatsStorage().getChatListByType(models_1.GROUP_TYPE.PRIVATE);
        const processedChats = this.prepareChatList(newChats);
        const nonDeletedChats = Object.assign(Object.assign({}, processedChats), { chats: processedChats.chats.filter(c => c.status !== models_1.CHAT_STATUS.DELETED) });
        if (chatList) {
            const { mergedItems } = (0, CollectionUtils_1.mergeAppendToArray)(chatList.chats, nonDeletedChats.chats, c => c.id, order, showMergedChatsOnTop);
            if (chatList) {
                chatList = Object.assign(Object.assign(Object.assign({}, mergeHandler(chatList, nonDeletedChats)), { chats: mergedItems }), (chatFilters && { chatFilters }));
            }
        }
        this.getChatsStorage().setChatListByType(models_1.GROUP_TYPE.PRIVATE, chatList);
    }
    getGroupType() {
        return models_1.GROUP_TYPE.PRIVATE;
    }
    getChatType() {
        return models_1.CHAT_TYPE.PRIVATE;
    }
    fetchGroupChatList(chatRequestBody, requestFilters, context) {
        return __awaiter(this, void 0, void 0, function* () {
            const chatListResponse = yield this.httpAdapter
                .getChatAdapter()
                .getPrivateChatList(chatRequestBody, context);
            if (!chatListResponse.isAborted) {
                const newChats = yield (0, mappers_1.privateChatsMapper)(chatListResponse.data);
                this.populateChatList(newChats, "APPEND", (_, newChats) => {
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    const { chats, chatFilters } = newChats, restData = __rest(newChats, ["chats", "chatFilters"]);
                    return Object.assign({}, restData);
                }, true, requestFilters);
            }
        });
    }
}
exports.BasePrivateChats = BasePrivateChats;
